module.exports = __webpack_public_path__ + "img/coldway-header-responsive.2f1fe519.jpg";